/** Совпадает с `SHOP_ENABLED` на бэкенде. */
export function isShopEnabled(): boolean {
    return useRuntimeConfig().public.shopEnabled === true
}
